// extracted by mini-css-extract-plugin
module.exports = {"vendorName":"style_vendorName__3fzdu","btnSecondaryGrey":"style_btnSecondaryGrey__3P3lz","waves-effect":"style_waves-effect__146OG"};